import "./../css/FlexBoxes.css";

const FlexBoxes = ({ children }) => {
  return <div className={"flexBoxes_container"}>{children}</div>;
};
export default FlexBoxes;
